import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import { FetchResponse } from '../dd_panel_patient_profiles/types.ts'
import { Survey } from './types.ts'

const getSurveys = async () => {
  let fetchResponse = {
    data: null as Survey[] | null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get<Survey[]>(
      '/api/surveys/dd_panel_survey_templates/'
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const toggleCode = async (survey_id: number, user_assignment_code: string) => {
  let fetchResponse = {
    data: {},
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.post(
      `/api/surveys/dd_panel_survey_templates/${survey_id}/toggle_code_assignation/`,
      {user_assignment_code}
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const getPatientSurveyDetails = async <T>(
  patientSurveyId: number
): Promise<FetchResponse<T>> => {
  const fetchResponse: FetchResponse<T> = {
    data: null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get<T>(
      `/api/surveys/dd_panel_patient_surveys/${patientSurveyId}`
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

export const surveysAPI = {
  getSurveys,
  toggleCode,
  getPatientSurveyDetails
}
